import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ContabilidadMaestrosService {
  private readonly contabilidadMaestros = [
    { nombre: 'Códigos de Artículos para Gastos', ruta: 'gastos-codigos-articulos' },
  ];

  getMaestros() {
    return this.contabilidadMaestros;
  }
}
